import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";
import AuthService from "./auth.service";

class PurchaseService {
  getPurchases(params = {}) {
    return axios
      .get(`${config.apiUrl}purchases`, {
        headers: authHeader(),
        params: params,
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error fetching purchases:", err);
        throw err;
      });
  }

  getPurchase(stamp) {
    return axios
      .get(`${config.apiUrl}purchases/show/${stamp}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error fetching purchase detail:", err);
        throw err;
      });
  }

  createPurchase(data) {
    return axios
      .post(`${config.apiUrl}purchases`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error creating purchase:", err);
        throw err;
      });
  }

  updatePurchase(stamp, data) {
    return axios
      .put(`${config.apiUrl}purchases/${stamp}`, data, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error updating purchase:", err);
        throw err;
      });
  }

  deletePurchase(stamp) {
    return axios
      .delete(`${config.apiUrl}purchases/${stamp}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.error("Error deleting purchase:", err);
        throw err;
      });
  }

  getFormOptions() {
    return axios
      .get(`${config.apiUrl}purchases/options`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error fetching purchase options:", err);
        throw err;
      });
  }

  getSuppliers() {
    return axios
      .get(`${config.apiUrl}purchases/suppliers`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error fetching suppliers for purchases:", err);
        throw err;
      });
  }

  getPurchaseFiles(stamp) {
    return axios
      .get(`${config.apiUrl}purchases/${stamp}/files`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error fetching purchase files:", err);
        throw err;
      });
  }

  uploadPurchaseFile(stamp, formData) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(`${config.apiUrl}purchases/${stamp}/files`, formData, {
        headers: headers,
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error uploading purchase file:", err);
        throw err;
      });
  }

  downloadPurchaseFile(stamp, fileId) {
    return axios.get(`${config.apiUrl}purchases/${stamp}/files/${fileId}`, {
      headers: authHeader(),
      responseType: "blob",
    });
  }

  deletePurchaseFile(stamp, fileId) {
    return axios
      .delete(`${config.apiUrl}purchases/${stamp}/files/${fileId}`, {
        headers: authHeader(),
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error deleting purchase file:", err);
        throw err;
      });
  }
}

export default new PurchaseService();
